import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-0 fw-bold" }
const _hoisted_2 = { class: "linked-width" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, { class: "card--slim card--module mb-2" }, {
    content: _withCtx(() => [
      _createVNode("span", {
        class: ["slot-indicator", _ctx.slotClass]
      }, null, 2),
      _createVNode("div", _hoisted_1, _toDisplayString(_ctx.slotName), 1),
      _createVNode("div", _hoisted_2, _toDisplayString(_ctx.linkDescription), 1)
    ]),
    _: 1
  }))
}